import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput, {
  outlinedInputClasses,
} from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';

import { FIELD_PADDING_PX } from 'theme/components/field-geometry';
import {
  SEARCH_CLEAR_TARGET_PX,
  SEARCH_ICON_PX,
  SEARCH_VALUE_GAP_PX,
} from 'ui/search-field/search-field.constants';
import type { SearchFieldSize } from 'ui/search-field/search-field.types';

interface FieldSizeOwnerState {
  fieldSize: SearchFieldSize;
}

const shouldForwardProp = (prop: PropertyKey) => prop !== 'fieldSize';

const clearOverflowPx = (size: SearchFieldSize) =>
  (SEARCH_CLEAR_TARGET_PX - SEARCH_ICON_PX[size]) / 2;

export const SearchFieldControl = styled(OutlinedInput, {
  shouldForwardProp,
})<FieldSizeOwnerState>(({ fieldSize }) => ({
  '&&': {
    paddingLeft: FIELD_PADDING_PX[fieldSize].x,
    paddingRight: FIELD_PADDING_PX[fieldSize].x,
  },
  [`&& .${outlinedInputClasses.input}`]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const SearchIconAdornment = styled(InputAdornment, {
  shouldForwardProp,
})<FieldSizeOwnerState>(({ theme, fieldSize }) => ({
  height: 'auto',
  maxHeight: 'none',
  margin: 0,
  marginRight: SEARCH_VALUE_GAP_PX,
  color: theme.palette.tokens.gray[500],
  '& svg': {
    width: SEARCH_ICON_PX[fieldSize],
    height: SEARCH_ICON_PX[fieldSize],
  },
}));

export const SearchClearAdornment = styled(InputAdornment)({
  height: 'auto',
  maxHeight: 'none',
  margin: 0,
});

export const SearchClearButton = styled(IconButton, {
  shouldForwardProp,
})<FieldSizeOwnerState>(({ theme, fieldSize }) => ({
  width: SEARCH_CLEAR_TARGET_PX,
  height: SEARCH_CLEAR_TARGET_PX,
  padding: 0,
  marginLeft: SEARCH_VALUE_GAP_PX - clearOverflowPx(fieldSize),
  marginRight: -clearOverflowPx(fieldSize),
  color: theme.palette.tokens.gray[700],
  '& svg': {
    width: SEARCH_ICON_PX[fieldSize],
    height: SEARCH_ICON_PX[fieldSize],
  },
}));
